import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ContentMessagingComponent } from './content-messaging.component';
import { ContentMessagingService } from '@services/content-messaging/content-messaging.service';
import { DlsHorizontalScrollModule } from '@zelis/dls/horizontal-scroll';
import { DlsCalloutCardModule } from '@zelis/dls/callout-card';
import { DlsIconModule } from '@zelis/dls/icons';
import { DlsClampModule } from '@zelis/dls/clamp';
import { DlsButtonModule } from '@zelis/dls/button';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    DlsHorizontalScrollModule,
    DlsCalloutCardModule,
    DlsIconModule,
    DlsClampModule,
    DlsButtonModule,
  ],
  declarations: [ContentMessagingComponent],
  exports: [ContentMessagingComponent],
  providers: [ContentMessagingService],
})
export class ContentMessagingModule {}
